import { Component } from '@angular/core';

@Component({
  selector: 'add-product-multiple-dialog',
  templateUrl: './add-product-multiple-dialog.component.html',
  styleUrls: ['./add-product-multiple-dialog.component.scss']
})
export class AddProductMultipleDialogComponent {

}
